<template>
    <Head>
        <title>Wakaf Pahang - Kaunter HQ</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <header ref="header" class="container-fluid p-2 fixed-top bg-wakaf-primary">
        <div class="d-flex flex-column align-items-center">
            <p class="fs-3 fw-bold text-white text-center">Pembayaran wakaf melalui kaunter (Ibu Pejabat) </p>
        </div>
    </header>
    <form @submit.prevent="submitForm" novalidate>
        <div ref="body" class="container-fluid">
            <div class="row">
                <div class="col">
                    <p class="fs-6">Pegawai <span class="fw-bold">{{ officer.Nama }} ({{ officer.KodPegawai}})</span> di pejabat <span class="fw-bold">{{ office_name }}</span></p>
                    <div v-for="(label,index) in displaylabel" :key="index" class="form-check form-check-inline">
                        <input class="form-check-input" @change="switchDisplay(index)" type="radio" :id="'form_'+index" name="formData" v-model="toggleSwitchType" :value="index">
                        <label class="form-check-label" :for="'form_'+index">{{ label }}</label>
                    </div>
                </div>
            </div>

            <div v-if="toggleSwitchType === 0" class="row mt-3">
                <div class="row">
                    <div class="col-md-12">
                        <div class="alert alert-primary">
                            <p class="fs-6"><font-awesome-icon :icon="faCircleInfo" class="me-2" />Ruangan unit wakaf akan dikira secara <b>automatik</b>. Sekiranya amaun adalah <b>bukan gandaan 5 atau ada sen perpuluhan maka bilangan unit menjadi 0</b>, bagi <b>gandaan 5, unit akan dikira automatik</b></p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="nokp" class="form-label">No. My Kad/Passport/Anggota</label>
                            <input type="text" v-model="pewakaf.noKP" class="form-control" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.noKP === ''}" id="nokp" placeholder="No. My Kad/Passport/Anggota">
                            <div class="invalid-feedback">Sila masukkan No. KP/Passport.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="name" class="form-label">Nama</label>
                            <input type="text" v-model="pewakaf.nama" class="form-control" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.nama === ''}" id="name" placeholder="Nama penuh">
                            <div class="invalid-feedback">Sila masukkan nama.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="daerahPembayar" class="form-label">Daerah pembayar</label>
                            <select v-model="pewakaf.daerahPewakaf" class="form-select" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.daerahPewakaf === 0}" id="daerahPembayar">
                                <option :value="0" disabled>Sila Pilih</option>
                                <option v-for="daerah in district" :key="daerah.KodDaerah" :value="daerah.KodDaerah">{{ daerah.Daerah }}</option>
                            </select>
                            <div class="invalid-feedback">Sila pilih daerah pembayar.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="emel" class="form-label">E-mel</label>
                            <input type="text" v-model="pewakaf.emel" class="form-control" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && !validateEmail(pewakaf.emel)}" id="emel" placeholder="E-mel">
                            <div class="invalid-feedback">Sila masukkan e-mel yang sah.</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="bentukbayar" class="form-label">Bentuk bayar</label>
                            <select v-model="pewakaf.bentukBayar" id="bentukbayar" class="form-select" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.bentukBayar === 0}">
                                <option :value="0" disabled>Sila Pilih</option>
                                <option v-for="ptype in bbayar" :key="ptype.ID" :value="ptype.ID">{{ ptype.nama }}</option>
                            </select>
                            <div class="invalid-feedback">Sila pilih bentuk bayar.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="amount" class="form-label">Amaun</label>
                            <input type="text" v-model="pewakaf.amaun" class="form-control text-end"
                                   :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && (pewakaf.amaun === '' || pewakaf.amaun === '0')}"
                                   id="amount"
                                   placeholder="0.00"
                                   @input="typeValueUpdate(($event.target as HTMLInputElement).value)"
                                   @focus="handleAmountFocus"
                                   @blur="handleAmountBlur">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="referer" class="form-label">No rujukan</label>
                            <input type="text" v-model="pewakaf.rujukan" class="form-control" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.rujukan === ''}" id="referer" placeholder="No rujukan bank atau seumpamanya">
                            <div class="invalid-feedback">Sila masukkan rujukan.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="banks" class="form-label">Bank</label>
                            <select v-model="pewakaf.bank" @change="getKodBank(pewakaf.bank, 0)" class="form-select" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.bank === 0}" id="banks">
                                <option :value="0" disabled>Sila Pilih</option>
                                <option v-for="bank in bankk" :key="bank.ID" :value="bank.ID">{{ bank.NamaBank }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-3">
                        <div class="mb-3">
                            <label class="label">Kod bank</label>
                            <multiselect v-model="pewakaf.kodbank" :options="kodBankMasukManual" :disabled="pewakaf.isDisabledKodBank" :custom-label="optionsLabel" placeholder="Pilih kod bank"></multiselect>
                            <div v-if="formSubmitted && toggleSwitchType === 0 && pewakaf.kodbank === null" class="text-danger small mt-1">Sila pilih kod bank.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="phone" class="form-label">Nombor telefon</label>
                            <input type="text" v-model="pewakaf.notel" class="form-control" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && !validatePhone(pewakaf.notel)}" id="phone" placeholder="Nombor yang boleh dihubungi">
                            <div class="form-text">Contoh: 0129012345</div>
                            <div class="invalid-feedback">No. telefon tidak sah.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label for="datetime" class="form-label">Tarikh masa</label>
                            <div :class="{'is-invalid-custom': formSubmitted && toggleSwitchType === 0 && pewakaf.tarikhmasa === ''}">
                                <VueDatePicker v-model="pewakaf.tarikhmasa" :locale="ms" placeholder="Pilih Tarikh/Masa"></VueDatePicker>
                            </div>
                            <div v-if="formSubmitted && toggleSwitchType === 0 && pewakaf.tarikhmasa === ''" class="text-danger small mt-1">Sila pilih tarikh.</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label class="form-label">Catatan</label>
                            <input type="text" v-model="pewakaf.catatan" class="form-control" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.catatan === ''}" placeholder="Catatan resit">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="mb-3">
                            <label class="form-label">Jenis wakaf</label>
                            <select class="form-select" v-model="pewakaf.jenisWakaf" @change="wakafDaerah(Number(($event.target as HTMLSelectElement).value))" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.jenisWakaf === 0}">
                                <option :value="0" disabled>Sila Pilih</option>
                                <option v-for="type in wakaf_type" :key="type.id" :value="type.id">{{ type.Nama }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="!pewakaf.isHiddenDistrict" class="col-md-3">
                        <div class="mb-3">
                            <label class="form-label">Daerah wakaf</label>
                            <select class="form-select" v-model="pewakaf.daerahWakaf" @change="daerahProjek(pewakaf.jenisWakaf, pewakaf.daerahWakaf)" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.daerahWakaf === 0}">
                                <option :value="0" disabled>Pilih daerah</option>
                                <option v-for="daerah in district_list" :key="daerah.KodDaerah" :value="daerah.KodDaerah">{{ daerah.daerah }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="!pewakaf.isHiddenProject" class="col-md-3">
                        <div class="mb-3">
                            <label class="form-label">Projek wakaf</label>
                            <select class="form-select" v-model="pewakaf.projekWakaf" :class="{'is-invalid': formSubmitted && toggleSwitchType === 0 && pewakaf.projekWakaf === 0}">
                                <option :value="0" disabled>Pilih projek</option>
                                <option v-for="project in project_list" :key="project.kod" :value="project.kod">{{ project.nama }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="toggleSwitchType === 1">
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="alert alert-primary">
                            <p class="fs-6"><font-awesome-icon :icon="faCircleInfo" class="me-2" />Pilihan wakaf adalah <b>Wakaf Tunai</b> dan pilihan daerah adalah <b>Seluruh Pahang</b> di bawah nama <b>Pembayar wakaf yang tidak diketahui</b></p>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <a rel=”noopener” target="_blank" class="btn btn-outline-primary me-2" :href="kodbank_list_update_uri">Senarai kod bank</a>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <label class="form-label">Bentuk bayar</label>
                        <select class="form-select" v-model="duitNowTransfer.bentukBayar" :class="{'is-invalid': formSubmitted && toggleSwitchType === 1 && duitNowTransfer.bentukBayar === 0}">
                            <option :value="0" disabled>Sila pilih</option>
                            <option v-for="b in bbayar" :key="b.ID" :value="b.ID">{{ b.nama }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Bank</label>
                        <select class="form-select" v-model="duitNowTransfer.bank" @change="getKodBank(duitNowTransfer.bank, 1)" :class="{'is-invalid': formSubmitted && toggleSwitchType === 1 && duitNowTransfer.bank === 0}">
                            <option :value="0" disabled>Sila pilih</option>
                            <option v-for="bank in bankk" :key="bank.ID" :value="bank.ID">{{ bank.NamaBank }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Kod bank</label>
                        <multiselect v-if="isMounted" v-model="duitNowTransfer.kodBank" :options="kodBankDuitNow" :disabled="duitNowTransfer.isDisabledKodBank" :custom-label="optionsLabel" placeholder="Pilih kod bank"></multiselect>
                        <div v-if="formSubmitted && toggleSwitchType === 1 && duitNowTransfer.kodBank === null" class="text-danger small mt-1">Sila pilih kod bank.</div>
                    </div>
                    <div class="col-md-3">
                        <form method="post" :action="downloadDuitNowExcel">
                            <input type="hidden" name="_token" :value="csrf">
                            <label for="formExcel" class="form-label">Upload fail Excel <button  class="btn btn-sm btn-outline-success fs-6"><font-awesome-icon :icon="faFileExcel" class="me-2" />Templat Excel</button></label>
                        </form>
                        <input ref="duitNowExcelFileRef" accept=".xls" class="form-control" type="file" @change="onFileChanged($event, 1)" :class="{'is-invalid': formSubmitted && toggleSwitchType === 1 && (!duitNowTransfer.failExcel || duitNowTransfer.failExcel.type !== 'application/vnd.ms-excel')}">
                        <div class="invalid-feedback">Sila muat naik fail .xls yang sah.</div>
                    </div>
                </div>
            </div>

            <div v-else-if="toggleSwitchType === 2">
                <div class="row mt-3">
                    <div class="col-md-12">
                        <a rel=”noopener” target="_blank" class="btn btn-outline-primary me-2" :href="kodbank_list_update_uri">Senarai kod bank</a>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <label class="form-label">Bentuk bayar</label>
                        <select class="form-select" v-model="paymentInfoComplete.bentukBayar" :class="{'is-invalid': formSubmitted && toggleSwitchType === 2 && paymentInfoComplete.bentukBayar === 0}">
                            <option :value="0" disabled>Sila pilih</option>
                            <option v-for="b in bbayar" :key="b.ID" :value="b.ID">{{ b.nama }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Bank</label>
                        <select class="form-select" v-model="paymentInfoComplete.bank" @change="getKodBank(paymentInfoComplete.bank, 2)" :class="{'is-invalid': formSubmitted && toggleSwitchType === 2 && paymentInfoComplete.bank === 0}">
                            <option :value="0" disabled>Sila pilih</option>
                            <option v-for="bank in bankk" :key="bank.ID" :value="bank.ID">{{ bank.NamaBank }}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Kod bank</label>
                        <multiselect v-model="paymentInfoComplete.kodBank" :options="kodBankOther" :disabled="paymentInfoComplete.isDisabledKodBank" :custom-label="optionsLabel" placeholder="Pilih kod bank"></multiselect>
                        <div v-if="formSubmitted && toggleSwitchType === 2 && paymentInfoComplete.kodBank === null" class="text-danger small mt-1">Sila pilih kod bank.</div>
                    </div>
                    <div class="col-md-3">
                        <form method="post" :action="downloadDuitNowExcelComplete">
                            <input type="hidden" name="_token" :value="csrf">
                            <label for="formExcelOther" class="form-label">Upload fail Excel <button  class="btn btn-sm btn-outline-success fs-6"><font-awesome-icon :icon="faFileExcel" class="me-2" />Templat Excel</button></label>
                        </form>
                        <input ref="paymentInfoCompleteExcel" accept=".xls" class="form-control" type="file" @change="onFileChanged($event, 2)" :class="{'is-invalid': formSubmitted && toggleSwitchType === 2 && (!paymentInfoComplete.failExcel || paymentInfoComplete.failExcel.type !== 'application/vnd.ms-excel')}">
                        <div class="invalid-feedback">Sila muat naik fail .xls yang sah.</div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="d-flex justify-content-end mt-5">
                        <button class="btn btn-success px-4" type="submit"><font-awesome-icon :icon="faPaperPlane" />&nbsp;&nbsp;Hantar</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="position-fixed" :class="{ 'd-none': !isDisplayLoader}" style="top: 0; inset: 0 0 0 0; background-color: rgba(255, 255, 255, 0.6); z-index: 1500"></div>
    <div class="loader-cover" :class="{ 'd-none': !isDisplayLoader}"></div>
    <div class="loader" :class="{ 'd-none': !isDisplayLoader}"></div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import axios from "axios";
import Swal from 'sweetalert2';
import { Head } from "@inertiajs/vue3";
import { faFileExcel, faPlus, faMinus, faPaperPlane, faTrash, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import type { pewakafQR } from "../interface/pewakafQR";
import { ms } from "date-fns/locale";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import {validateEmail, validatePhone} from "../../utils/utils";
import "@vuepic/vue-datepicker/dist/main.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";

library.add(faFileExcel, faPlus, faMinus, faPaperPlane, faTrash, faCircleInfo);

// INTERFACES
interface KodBank {
    id: number;
    kod: string;
    keterangan: string;
}

interface DuitNowForm {
    bentukBayar: number;
    bank: number;
    isDisabledKodBank: boolean;
    kodBank: KodBank | null;
    failExcel: File | null;
}

// PROPS
const data = defineProps<{
    csrf: string;
    submit_url: string;
    kodbank_url: string;
    kodbank_list_update_uri: string;
    downloadDuitNowExcel: string;
    downloadDuitNowExcelComplete: string;
    img_favicon: string;
    kpeg: string;
    kpej: number;
    district: { KodDaerah: number; Daerah: string }[];
    wakaf_type: { id: number; Nama: string }[];
    wakaf_district: { KodDaerah: number; WakafJenisID: number; daerah: string }[];
    wakaf_project: { kod: number; nama: string; WakafJenisID: number; DaerahID: number }[];
    bankk: { ID: number; NamaBank: string }[];
    officer: { KodPegawai: string; Nama: string; KodPejabat: string; KataKunci: string };
    bbayar: { ID: number; nama: string }[];
    office_name: string;
}>();

const isDisplayLoader = ref<boolean>(false);
const formSubmitted = ref<boolean>(false);
const toggleSwitchType = ref<number>(1);

const header = ref<HTMLDivElement | null>(null);
const body = ref<HTMLDivElement | null>(null);
const duitNowExcelFileRef = ref<HTMLInputElement | null>(null);
const paymentInfoCompleteExcel = ref<HTMLInputElement | null>(null);

const displaylabel = ref<string[]>(["Masuk manual", "DuitNow / Transfer", "Bentuk bayar dengan maklumat lengkap"]);
const district_list = ref<{ KodDaerah: number; daerah: string }[]>([]);
const project_list = ref<{ kod: number; nama: string }[]>([]);

const kodBankMasukManual = ref<KodBank[]>([]);
const kodBankDuitNow = ref<KodBank[]>([]);
const kodBankOther = ref<KodBank[]>([]);
const isMounted = ref(false);

const pewakaf = ref<pewakafQR>({
    noKP: "", nama: "", daerahPewakaf: 0, emel: "", notel: "", kodbank: null,
    bentukBayar: 0, amaun: "1", rujukan: "", bank: 0, catatan: "", tarikhmasa: "",
    jenisWakaf: 0, daerahWakaf: 0, projekWakaf: 0, isHiddenDistrict: true, isHiddenProject: true, isDisabledKodBank: true
});

const duitNowTransfer = ref<DuitNowForm>({
    bentukBayar: 18, bank: 0, isDisabledKodBank: true, kodBank: null, failExcel: null
});

const paymentInfoComplete = ref<DuitNowForm>({
    bentukBayar: 0, bank: 0, isDisabledKodBank: true, kodBank: null, failExcel: null
});


const optionsLabel = (item: KodBank): string => `${item.kod} - ${item.keterangan}`;

const switchDisplay = (index: number): void => {
    toggleSwitchType.value = index;
    formSubmitted.value = false;
};

onMounted(() => {
    isMounted.value = true;
    if (header.value && body.value) {
        body.value.style.marginTop = header.value.clientHeight + 10 + "px";
    }
});

// FORMATTING LOGIC
const handleAmountBlur = () => {
    const rawValue = pewakaf.value.amaun.replace(/,/g, '');
    if (isValidNumber(rawValue)) {
        pewakaf.value.amaun = parseFloat(rawValue).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    }
};

const handleAmountFocus = () => {
    pewakaf.value.amaun = pewakaf.value.amaun.replace(/,/g, '');
};

const onFileChanged = (event: Event, sw: number): void => {
    const target = event.target as HTMLInputElement;
    if (target && target.files && target.files[0]) {
        if (sw === 1) duitNowTransfer.value.failExcel = target.files[0];
        else if (sw === 2) paymentInfoComplete.value.failExcel = target.files[0];
    }
};

const getKodBank = (bankID: number, sw: number): void => {
    isDisplayLoader.value = true;
    axios.post(data.kodbank_url, { csrf: data.csrf, id: bankID }).then((res) => {
        const result: KodBank[] = res.data;
        if (sw === 0) {
            kodBankMasukManual.value = result;
            pewakaf.value.isDisabledKodBank = result.length === 0;
            pewakaf.value.kodbank = null;
        } else if (sw === 1) {
            kodBankDuitNow.value = result;
            duitNowTransfer.value.isDisabledKodBank = result.length === 0;
            duitNowTransfer.value.kodBank = null;
        } else if (sw === 2) {
            kodBankOther.value = result;
            paymentInfoComplete.value.isDisabledKodBank = result.length === 0;
            paymentInfoComplete.value.kodBank = null;
        }
    }).catch(() => {
        Swal.fire({ icon: "error", title: "Ralat", text: "Gagal memuat kod bank" });
    }).finally(() => isDisplayLoader.value = false);
};

const typeValueUpdate = (typedValue: string): void => {
    const raw = typedValue.replace(/,/g, '');
    if (!isValidNumber(raw)) pewakaf.value.amaun = "1";
};

const isValidNumber = (number: string): boolean => {
    return (!isNaN(Number(number)) && parseFloat(number) > 0 && parseFloat(number) <= 5000000 && !(number.includes(".") && number.split(".")[1].length > 2));
};

const wakafDaerah = (jenisWakaf: number): void => {
    pewakaf.value.isHiddenDistrict = true;
    pewakaf.value.isHiddenProject = true;
    district_list.value = [];
    project_list.value = [];
    pewakaf.value.daerahWakaf = 0;
    pewakaf.value.projekWakaf = 0;

    switch (jenisWakaf){
        case 3: // Tabung wakaf masjid
            pewakaf.value.daerahWakaf = 99;
            pewakaf.value.projekWakaf = 3;
            break;
        case 4: // Tabung wakaf pendidikan
            pewakaf.value.daerahWakaf = 99;
            pewakaf.value.projekWakaf = 5;
            break;
        case 5: // Wakaf tunai
            pewakaf.value.daerahWakaf = 99;
            pewakaf.value.projekWakaf = 58;
            break;
        default:
            // Tabung wakaf umum
            if(jenisWakaf === 1){
                pewakaf.value.projekWakaf = 26;
            }
            // Restore the original helper function call
            const districts: { KodDaerah: number, daerah: string }[] = getDaerahProjectIncluded();
            district_list.value = districts;
            pewakaf.value.isHiddenDistrict = false;
    }
};

const getDaerahProjectIncluded = () : { KodDaerah: number, daerah: string }[] =>{
    let filteredDistricts: { KodDaerah: number, daerah: string }[] = [];
    const uniqueDistrictIDs = new Set();
    for (let p = 0; p < data.wakaf_project.length; p++){
        if(![3,5,26].includes(data.wakaf_project[p].kod) && data.wakaf_project[p].WakafJenisID ===2){
            uniqueDistrictIDs.add(data.wakaf_project[p].DaerahID);
        }
    }
    for (let q = 0; q < data.wakaf_district.length; q++){
        if(uniqueDistrictIDs.has(data.wakaf_district[q].KodDaerah)){
            filteredDistricts.push({
                KodDaerah : data.wakaf_district[q].KodDaerah,
                daerah : data.wakaf_district[q].daerah
            });
        }
    }
    return filteredDistricts;
}

const daerahProjek = (jenisWakaf: number, daerah: number): void => {
    project_list.value = [];
    if(pewakaf.value.jenisWakaf !== 1){
        pewakaf.value.projekWakaf = 0;
    }
    let filteredProjects: { kod: number, nama: string }[] = getProjectFiltered(jenisWakaf, daerah);
    if(filteredProjects.length > 0){
        pewakaf.value.isHiddenProject = false;
        project_list.value = filteredProjects;
    }
};

const getProjectFiltered = (jenisWakaf: number, daerah: number) : { kod: number, nama: string }[] =>{
    let filteredProjects: { kod: number, nama: string }[] = [];
    data.wakaf_project.forEach(function (item) {
        if (item["WakafJenisID"] === jenisWakaf && item["DaerahID"] === daerah) {
            filteredProjects.push({
                kod : item["kod"],
                nama : item["nama"]
            });
        }
    });
    return filteredProjects;
}

const submitForm = (): void => {
    formSubmitted.value = true;
    if (toggleSwitchType.value === 0 && !formValidationManual()) return;
    if (toggleSwitchType.value === 1 && !formValidationDuitNowTransfer()) return;
    if (toggleSwitchType.value === 2 && !formValidationPaymentInfoComplete()) return;

    Swal.fire({
        title: "Anda pasti untuk hantar?",
        showConfirmButton: true, confirmButtonColor: "#198754", confirmButtonText: "Ya",
        showCancelButton: true, cancelButtonText: "Kembali", cancelButtonColor: "#fa184d",
        reverseButtons: true, showLoaderOnConfirm: true,
        preConfirm: () => {
            if (toggleSwitchType.value === 0) {
                const payload = {
                    channel: 1, kpeg: data.kpeg, kpej: data.kpej, nokp: pewakaf.value.noKP, name: pewakaf.value.nama,
                    daerahPewakaf: pewakaf.value.daerahPewakaf, emel: pewakaf.value.emel, type: pewakaf.value.bentukBayar,
                    amount: pewakaf.value.amaun.replace(/,/g, ''), // Strip commas for DB
                    referer: pewakaf.value.rujukan, bank: pewakaf.value.bank,
                    tarikhmasa: pewakaf.value.tarikhmasa, catatan: pewakaf.value.catatan, phone: pewakaf.value.notel,
                    kodbank: pewakaf.value.kodbank?.id, typeWakaf: pewakaf.value.jenisWakaf,
                    districtWakaf: pewakaf.value.daerahWakaf, projectWakaf: pewakaf.value.projekWakaf
                };
                return axios.post(data.submit_url, payload).then(() => {
                    Swal.fire({ icon: 'success', title: 'Berjaya' });
                    formSubmitted.value = false;
                    pewakaf.value = {
                        noKP: "", nama: "", daerahPewakaf: 0, emel: "", notel: "", kodbank: null,
                        bentukBayar: 0, amaun: "1", rujukan: "", bank: 0, catatan: "", tarikhmasa: "",
                        jenisWakaf: 0, daerahWakaf: 0, projekWakaf: 0, isHiddenDistrict: true,
                        isHiddenProject: true, isDisabledKodBank: true
                    };
                });
            } else {
                const active = toggleSwitchType.value === 1 ? duitNowTransfer.value : paymentInfoComplete.value;
                const form = new FormData();
                form.append("csrf", data.csrf);
                form.append("kpeg", data.kpeg);
                form.append("kpej", data.kpej.toString());
                form.append("channel", (toggleSwitchType.value + 1).toString());
                form.append("type", active.bentukBayar.toString());
                form.append("bank", active.bank.toString());
                form.append("kodbank", active.kodBank?.id.toString() || "");
                form.append("excel", active.failExcel as Blob);
                return axios.post(data.submit_url, form).then(() => {
                    Swal.fire({ icon: 'success', title: 'Berjaya' });
                    formSubmitted.value = false;
                    duitNowTransfer.value = {
                        bentukBayar: 18,
                        bank: 0,
                        isDisabledKodBank: true,
                        kodBank: null,
                        failExcel: null
                    };
                });
            }
        }
    });
};

const formValidationManual = (): boolean => {
    let formValidation: boolean = true;
    if(pewakaf.value.noKP === ""){ formValidation = false; }
    if(pewakaf.value.nama === ""){ formValidation = false; }

    // NEW VALIDATION: Check for Payer District
    if(pewakaf.value.daerahPewakaf === 0){ formValidation = false; }

    if(pewakaf.value.bentukBayar === 0){ formValidation = false; }
    if(pewakaf.value.amaun === ""){ formValidation = false; }
    if(pewakaf.value.rujukan === ""){ formValidation = false; }
    if(pewakaf.value.bank === 0){ formValidation = false; }
    if(pewakaf.value.tarikhmasa === ""){ formValidation = false; }
    if(pewakaf.value.catatan === ""){ formValidation = false; }

    if(!new RegExp("^(01)[02-46-9][0-9]{7}$|^(01)1[0-9]{8}$|^(0)[2-9][0-9]{6,8}$", "g").test(pewakaf.value.notel)){
        formValidation = false;
    }
    if(!new RegExp("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$", "g").test(pewakaf.value.emel)){
        formValidation = false;
    }
    if(pewakaf.value.kodbank === null){ formValidation = false; }
    if(pewakaf.value.jenisWakaf === 0){ formValidation = false; }
    if(pewakaf.value.daerahWakaf === 0){ formValidation = false; }
    if(pewakaf.value.projekWakaf === 0){ formValidation = false; }

    return formValidation;
};

const formValidationDuitNowTransfer = (): boolean => {
    return duitNowTransfer.value.bentukBayar !== 0 && duitNowTransfer.value.bank !== 0 &&
        duitNowTransfer.value.kodBank !== null && duitNowTransfer.value.failExcel?.type === "application/vnd.ms-excel";
};

const formValidationPaymentInfoComplete = (): boolean => {
    return paymentInfoComplete.value.bentukBayar !== 0 && paymentInfoComplete.value.bank !== 0 &&
        paymentInfoComplete.value.kodBank !== null && paymentInfoComplete.value.failExcel?.type === "application/vnd.ms-excel";
};
</script>

<style scoped>
.loader { height: 10px; width: 100%; background: no-repeat linear-gradient(#5a1c50 0 0), no-repeat linear-gradient(#5a1c50 0 0), #d7b8fc; background-size: 60% 100%; animation: loader 3s infinite; position: fixed; bottom: 0; z-index: 7; }
.loader-cover { height: 40px; width: 100%; background: no-repeat linear-gradient(#5a1c50 0 0), no-repeat linear-gradient(#5a1c50 0 0), #ffffff; background-size: 60% 100%; animation: loader 3s infinite; position: fixed; bottom: 10px; z-index: 6; opacity: 0.15; filter: blur(10px); }
@keyframes loader { 0% { background-position:-150% 0,-150% 0; } 66% { background-position: 250% 0,-150% 0; } 100% { background-position: 250% 0, 250% 0; } }
</style>
